module.exports = __webpack_public_path__ + "img/result-duration.18e3e183.png";